import React, { PureComponent } from 'react'

import InlineSVG from 'svg-inline-react'

export default class TutorialIcon extends PureComponent
{
	render ()
	{
		const component = this, props = this.props, state = this.state;

		const svg_source =
		(
			`<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">
				<path fill="currentColor" d="M1006.934 887.467h-989.867c-9.426 0-17.067-7.641-17.067-17.067v0-392.533h34.133v375.467h955.733v-682.667h-955.733v204.8h-34.133v-221.867c0-9.426 7.641-17.067 17.067-17.067v0h989.867c9.426 0 17.067 7.641 17.067 17.067v0 716.8c0 9.426-7.641 17.067-17.067 17.067v0z"></path>
				<path fill="currentColor" d="M0.001 409.6h34.133v34.133h-34.133z"></path>
				<path fill="currentColor" d="M1006.934 307.2h-989.867c-9.426 0-17.067-7.641-17.067-17.067v0-136.533c0-9.426 7.641-17.067 17.067-17.067v0h989.867c9.426 0 17.067 7.641 17.067 17.067v0 136.533c0 9.426-7.641 17.067-17.067 17.067v0zM34.134 273.067h955.733v-102.4h-955.733z"></path>
				<path fill="currentColor" d="M68.268 204.8h34.133v34.133h-34.133z"></path>
				<path fill="currentColor" d="M136.534 204.8h34.133v34.133h-34.133z"></path>
				<path fill="currentColor" d="M204.801 204.8h34.133v34.133h-34.133z"></path>
				<path fill="currentColor" d="M512.001 785.067c-113.108 0-204.8-91.692-204.8-204.8s91.692-204.8 204.8-204.8c113.108 0 204.8 91.692 204.8 204.8v0c-0.126 113.057-91.743 204.674-204.788 204.8h-0.012zM512.001 409.6c-94.257 0-170.667 76.41-170.667 170.667s76.41 170.667 170.667 170.667c94.257 0 170.667-76.41 170.667-170.667v0c-0.107-94.213-76.453-170.56-170.656-170.667h-0.011z"></path>
				<path fill="currentColor" d="M460.801 682.667c-9.426 0-17.067-7.641-17.067-17.067v0-170.667c0 0 0 0 0 0 0-9.426 7.641-17.067 17.067-17.067 3.351 0 6.478 0.966 9.116 2.636l-0.070-0.042 136.533 85.333c4.88 3.060 8.076 8.411 8.076 14.507s-3.197 11.446-8.005 14.465l-0.071 0.042-136.533 85.333c-2.542 1.586-5.629 2.526-8.935 2.526-0.038 0-0.077 0-0.115 0h0.006zM477.868 525.739v109.141l87.262-54.613z"></path>
			</svg>`
		);

		let output =
		(
			<InlineSVG src={ svg_source } className={ props.className }
				raw={ true }
			/>
		);

		return output;
	}
}